import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface InvsmtRommsProps {
  onBack: () => void;
}

export default function InvsmtRomms({ onBack }: InvsmtRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Investments" />;
}



